import { keyframes, SxProps } from "@mui/material";

const pulse = keyframes`
    0% { opacity: 0.35; }
    50% { opacity: 0.85; }
    100% { opacity: 0.35; }
  `;
export const skeletonMuiBarElementStyle: SxProps = {
  // Target bar elements and animate their opacity to mimic a skeleton pulse
  "& .MuiBarElement-root": {
    animation: `${pulse} 1.6s ease-in-out infinite`,
  },
  // Slight stagger for visual richness
  "& .MuiBarElement-root:nth-of-type(odd)": {
    animationDelay: "0.25s",
  },
};
